// extracted by mini-css-extract-plugin
export var backarrow = "BurgerMenuMobile-module--backarrow--7337b";
export var burgermenucontainer = "BurgerMenuMobile-module--burgermenucontainer--bb4e0";
export var burgermenuhidden = "BurgerMenuMobile-module--burgermenuhidden--fa201";
export var primarylink = "BurgerMenuMobile-module--primarylink--8704b";
export var primarylinkactive = "BurgerMenuMobile-module--primarylinkactive--7f3a8 BurgerMenuMobile-module--primarylink--8704b";
export var primarynavlist = "BurgerMenuMobile-module--primarynavlist--ec6ea";
export var secondarylink = "BurgerMenuMobile-module--secondarylink--5ec62";
export var secondarylinkactive = "BurgerMenuMobile-module--secondarylinkactive--4b178 BurgerMenuMobile-module--secondarylink--5ec62";
export var secondarynavhidden = "BurgerMenuMobile-module--secondarynavhidden--3af9c";
export var secondarynavlist = "BurgerMenuMobile-module--secondarynavlist--d468d";
export var secondarynavwrapper = "BurgerMenuMobile-module--secondarynavwrapper--38d5c";
export var secondarytitle = "BurgerMenuMobile-module--secondarytitle--330b5";
export var subMenuNavArrows = "BurgerMenuMobile-module--subMenuNavArrows--fac6f";
export var tertiarylink = "BurgerMenuMobile-module--tertiarylink--47eb8";
export var tertiarynavlist = "BurgerMenuMobile-module--tertiarynavlist--3fb79";
export var tertiarynavwrapper = "BurgerMenuMobile-module--tertiarynavwrapper--b6a98";